import classNames from "classnames";
import { Icon } from "PFComponents/icon";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./filters_button.scss";

type Props = {
  filtersAreClear?: boolean;
  filtersShown?: boolean;
  onClick?: () => void;
  withLabel?: boolean;
  disabled?: boolean;
  className?: string;
  qaId?: string;
  style?: React.CSSProperties;
};

const FiltersButton = ({
  filtersAreClear,
  filtersShown,
  onClick,
  withLabel,
  disabled,
  className,
  qaId,
  style
}: Props): JSX.Element => {
  const { t } = useTranslation("bookingModule");
  return (
    <div className={css.root} style={style}>
      {withLabel && <span>{t("filters.label")}</span>}
      <button
        className={classNames(css.filterIcon, className, {
          [css.filtered]: !filtersAreClear,
          [css.activeButton]: filtersShown,
          [css.disabled]: disabled
        })}
        onClick={onClick}
        id="filters_button"
        data-qa-id={qaId}
      >
        <Icon name="filter" size="sm" />

        <div className={classNames(css.blob, { [css.blobShown]: filtersShown })}>
          <svg width={60} height={80}>
            {/* eslint-disable-next-line max-len */}
            <path d="M 39.796875,0.1015625 C 28.830587,0.21294459 19.999435,9.1347102 20,20.101562 V 24 C 20,35.045695 11.045695,44.714535 0,44.714535 0,91.651156 60,80 60,74.955752 c 0,0 0,-40.189772 0,-54.85419 C 60,9.0558692 51.045695,0.1015625 40,0.1015625 c -0.06771,-3.4383e-4 -0.135417,-3.4383e-4 -0.203125,0 z" />
          </svg>
        </div>
      </button>
    </div>
  );
};

export default FiltersButton;
